<button class="trigger" (click)="onClick()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <svg [attr.viewBox]="viewBox">
        <g [attr.stroke-width]="isCross ? crossLineStroke : menuLineStroke" [class.contrast]="isCross">
            <path [attr.d]="isCross ? crossTopPath : menuTopPath"></path>
            <path [attr.d]="isCross ? crossMiddlePath : menuMiddlePath" [attr.opacity]="isCross ? 0 : 1"></path>
            <path [attr.d]="isCross ? crossBottomPath : menuBottomPath"></path>
        </g>
    </svg>
</button>
